import { useMemo } from 'react';
import { useFormPersonNumber } from './useFormPersonNumber';
import { useFormCommonNumber } from './useFormCommonNumber';

export const useFormChangeContact = (params = {}) => {
	const { values, isPersonal } = params;

	const { validationSchema: personalValidation } = useFormPersonNumber();
	const { validationSchema: commonValidation } = useFormCommonNumber();

	const statuses = useMemo(() => {
		return [
			{ label: 'Работает', value: 'avail' },
			{ label: 'Больше не работает', value: 'unavail' },
		];
	}, []);

	const defaultValues = useMemo(() => {
		return {
			target: null,
			contact: null,
			phone: '',
			name: '',
			secondName: '',
			thirdName: '',
			contacts: [{ type: null, text: '' }],
			job: null,
			decisionMaker: '1',
			comment: '',
			...values,
		};
	}, [values]);

	return {
		statuses,
		initialValues: defaultValues,
		validationSchema: isPersonal ? personalValidation : commonValidation,
	};
};
